﻿window.cBuilderEmailWidgetRGPDPolitiqueConf = function (option) {
    var Me = this

    this.mGetButton = function () {
        var $DivBt = $("<div class='widget state-hover' typewidget='dxwidgetrgpdpolitiqueconf'/>").css({
            "padding": "5px",
            "width": "80px",
            "height": "95px",
            "cursor": "move",
            "margin": "5px",
            border: "3px solid " + theme.backgroundColorTitle,
            "text-align": "center",
            "display": "inline-block"
        })
        var $I = $("<i class='" + Me.icone + " dx-theme-accent-as-text-color' style='font-size:260%;height:50px;'></i>").appendTo($DivBt)
        var $Div = $("<div style='font-family:barlow condensed;font-size:100%;height:calc(100% - 60px);display:flex;align-items:center;justify-content:center;line-height:1;'>RGPD:Politique confidentialité</div>").appendTo($DivBt)
        $DivBt.attr("title", "RGPD:<b>Ajouter votre politique de confidentialité</b><br/>Pour être conforme au RGPD, vous devez ajouter un lien vers votre politique de confidentialité dans votre email.<br/>" + parametre.nom + " vous propose une politique de confidentialité par défaut, contenant les informations essentielles à fournir.<br/>Si vous disposez de votre propre politique de confidentialité, il vous suffit d'ajouter un lien vers celle-ci dans votre email.'</i>.")
        return $DivBt
    }

    this.mCreateElement = function () {
        option.element = $("<tr class='widget dxwidgetrgpdpolitiqueconf'>")
        $("<!-- DEBUT RGPD Politique confidentialité -->").appendTo(option.element)
        var $Td = $("<td valign='top' style='word-break:break-word;with:100%;' width='100%' class='bodywidget tdwidget widgetheightauto'></td>").appendTo(option.element)
        var jsonDuplik = JSON.parse(JSON.stringify(option.dxBuilderEmailPage.mJsonCssGuideProperty("p")))
        for (var prop in jsonDuplik) jsonDuplik[prop] = ""
        $Td.attr("jsoncssdatawidget", JSON.stringify(jsonDuplik))

        var $TablePaddingBorder = $("<table  border='0' cellspacing='0' cellpadding='0' style='width:100%'/>").appendTo($Td)
        var $Tr = $("<tr/>").appendTo($TablePaddingBorder)
        var $Td = $("<td class='contenuwidget tdpaddingborderwidget'/>").appendTo($Tr)
        if (!option.bddCtrl.paraAppli.mGetPara("nom_societe_politique_confidentialite") || option.bddCtrl.paraAppli.mGetPara("nom_societe_politique_confidentialite").length == 0) {
            var dataSociete = option.bddCtrl.mGetArray("societe")[0]
            if (dataSociete) {
                option.bddCtrl.paraAppli.mGetPara("nom_societe_politique_confidentialite", dataSociete.nom)
            }
        }
        if (!option.bddCtrl.paraAppli.mGetPara("adresse_email_politique_confidentialite") || option.bddCtrl.paraAppli.mGetPara("adresse_email_politique_confidentialite").length == 0) {
            option.bddCtrl.paraAppli.mGetPara("adresse_email_politique_confidentialite", option.bddCtrl.utiCourant.adresse_email)
        }
        debugger
        if (!option.bddCtrl.paraAppli.mGetPara("mailing_text_lien_politique_confidentialite") || option.bddCtrl.paraAppli.mGetPara("mailing_text_lien_politique_confidentialite").length == 0) {
            option.bddCtrl.paraAppli.mGetPara("mailing_text_lien_politique_confidentialite", "Politique de confidentialité")
        }
        var $AA = $("<a href='about:blank' target='_blank' class='RGPDpopsoftAPolitiqueconfidentialite' nom_societe='' email_rgpd=''></a>").appendTo($Td).text(option.bddCtrl.paraAppli.mGetPara("mailing_text_lien_politique_confidentialite"))
        $AA.attr("nom_societe", option.bddCtrl.paraAppli.mGetPara("nom_societe_politique_confidentialite"))
        $AA.attr("email_rgpd", option.bddCtrl.paraAppli.mGetPara("adresse_email_politique_confidentialite"))

        $("<!-- FIN RGPD Politique confidentialité -->").appendTo(option.element)
    }

    this.nom = "RGPD:Politique confidentialité"
    this.icone = "fas fa-file-signature"
    function mGetLink() { return $(option.element.find("a")[0]) }

    var dxBuilderSaisieHtml = null
    this.mAddCtrlSaisie = function (contentElement) {
        contentElement.empty()

        $("<div style='font-family:barlow condensed;'>Ce composant génère un lien sur la politique de confidentialité par défaut de " + parametre.nom + ". Vous devez saisir le nom de votre société et l'adresse email du responsable RGPD pour pouvoir générer votre politique de confidentialité.<br/>Si vous avez votre propre politique de confidentialité, vous pouvez choisir de mettre un lien sur celle-ci plutôt que ce widget.</div>").appendTo(contentElement)
        var $A = $("<a href='javascript:void(0)'>Voir la politique de confidentialité par défaut</a>").appendTo(contentElement)
        $A.on("click", function (e) {
            //afficher la politique de confidentialité
            var rgpd = new cRgpd({ bddCtrl: option.bddCtrl })
            rgpd.mShowPolitiqueConfidentialite(mGetLink().attr("nom_societe"), mGetLink().attr("email_rgpd"), true)
        })

        contentElement.closest(".dx-item-content").css("overflow", "visible")
        //$("<div style='margin-top:10px;'/>").appendTo(contentElement).dxTextBox({
        //    labelMode: "floating",
        //    label:"Texte du lien",
        //    bddCtrl: option.bddCtrl,
        //    value: option.bddCtrl.paraAppli.mGetPara("mailing_text_lien_politique_confidentialite"),
        //    onValueChanged: function (e) {
        //        mGetLink().text(e.value)
        //        option.bddCtrl.paraAppli.mGetPara("mailing_text_lien_politique_confidentialite", e.value)
        //        option.onValueChanged()
        //    }
        //}).dxTextBox("instance")
        var dxEmoji = $("<div style='margin-top:20px;'/>").appendTo(contentElement).dxCtrlTxtEmoji({
            labelMode: "floating",
            label: "Texte du lien d'affichage de la politique de confidentialité",
            bddCtrl: option.bddCtrl,
            pickerPosition: "bottom",
            value: mGetLink().text(),
            onValueChanged: function (value) {
                if (value == null || value.length == 0) {
                    dxEmoji.mSetValue("Politique de confidentialité")
                } else {
                    mGetLink().text(value)
                    option.bddCtrl.paraAppli.mGetPara("mailing_text_lien_politique_confidentialite", value)
                    option.onValueChanged()
                }
            }
        }).dxCtrlTxtEmoji("instance")

        //$("<br/>").appendTo(contentElement)
        contentElement.closest(".dx-item-content").css("overflow", "visible")
        $("<div style='margin-top:10px;'/>").appendTo(contentElement).dxTextBox({
            labelMode: "floating",
            label: "Nom société",
            bddCtrl: option.bddCtrl,
            value: mGetLink().attr("nom_societe"),
            onValueChanged: function (e) {
                mGetLink().attr("nom_societe", e.value)
                option.bddCtrl.paraAppli.mGetPara("nom_societe_politique_confidentialite", e.value)
                option.onValueChanged()
            }
        }).dxTextBox("instance")

        //$("<br/>").appendTo(contentElement)
        contentElement.closest(".dx-item-content").css("overflow", "visible")
        $("<div style='margin-top:10px;'/>").appendTo(contentElement).dxTextBox({
            labelMode: "floating",
            label: "Email du responsable RGPD",
            bddCtrl: option.bddCtrl,
            value: mGetLink().attr("email_rgpd"),
            onValueChanged: function (e) {
                mGetLink().attr("email_rgpd", e.value)
                option.bddCtrl.paraAppli.mGetPara("adresse_email_politique_confidentialite", e.value)
                option.onValueChanged()
            }
        }).dxTextBox("instance")
    }

    this.mAddCtrlStyle = function (contentElement) {
        contentElement.empty()
        dxBuilderSaisieHtml = null

        var jsonCssDataOriginalValue = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        var jsonCssData = {}
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("p")) {
            jsonCssData[prop] = ""
            if (typeof jsonCssDataOriginalValue[prop] != 'undefined') jsonCssData[prop] = jsonCssDataOriginalValue[prop]
        }
        //$("<br/>").appendTo(contentElement)
        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;' class=''>Style du texte:</div>").appendTo(contentElement)
        $("<div/>").appendTo(contentElement).dxCtrlBuilderEmailStyleFont({
            dxBuilderEmailPage: option.dxBuilderEmailPage,
            value: jsonCssData,
            showAlign: false,
            allowDefaut: true,
            onValueChanged: function (e) {
                e.values.forEach(function (value) {
                    if (value.value != null && value.value.length > 0) { jsonCssDataOriginalValue[value.prop] = value.value }
                    else { delete jsonCssDataOriginalValue[value.prop] }
                })
                option.parent.mGetBodyWidget().attr("jsoncssdatawidget", JSON.stringify(jsonCssDataOriginalValue))
                option.onValueChanged()
            }
        })
    }

    this.mRemoveStyle = function () {
        var jsonCssData = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("p")) {
            delete jsonCssData[prop]
        }
        option.parent.mGetBodyWidget().attr("jsoncssdatawidget", JSON.stringify(jsonCssData))
        option.onValueChanged()
    }

    this.mUpdateCss = function () {
        var jsonCssData = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("p")) {
            if (typeof jsonCssData[prop] != 'undefined' && jsonCssData[prop].length > 0) {
                option.parent.mGetContenuWidget().css(prop, jsonCssData[prop])
                //if (prop == "text-align") option.parent.mGetContenuWidget().find("td").css(prop, jsonCssData[prop])
            } else {
                option.parent.mGetContenuWidget().css(prop, option.dxBuilderEmailPage.mJsonCssGuideProperty("p", prop))
                //if (prop == "text-align") option.parent.mGetContenuWidget().find("td").css(prop, option.dxBuilderEmailPage.mJsonCssGuideProperty("p", prop))
            }
        }
    }

}